import { http } from '@/utils/http';
import { getUrl } from '@/utils/getUrl';
import { getUserAuthUrl } from '@/utils/getUserAuthUrl';
import { withDevelopmentHeaders } from '@/utils/withDevelopmentHeaders';

export type AlltIdUserCode = string;
export type CreateAccountPasswordless = (
  userData: { firstName: string; lastName: string; email: string },
  newsletterSubscription: boolean,
) => Promise<{ alltIdUserCode: AlltIdUserCode; isNewUser: boolean }>;

export const createAccountPasswordless: CreateAccountPasswordless = async (userData, newsletterSubscription) => {
  const { firstName, lastName, email } = userData;

  const response = await http.post('/api/alltid/passwordless', {
    email,
    lastname: lastName,
    name: firstName,
    newsletterSubscription,
  });

  const { message } = response?.data || {};
  const { cc: alltIdUserCode, isNewUser } = message || {};

  if (!alltIdUserCode) {
    throw new Error('Could not create passwordless account');
  }

  return { alltIdUserCode, isNewUser };
};

export const fetchUserDetails = async (alltidUserCC: string): Promise<any> => {
  const url = getUrl('api/user/by-cc', getUserAuthUrl());

  if (!url) {
    throw new Error('Invalid URL for user details fetch');
  }

  const response = await http.post(
    url?.href,
    { cc: alltidUserCC },
    {
      headers: { Authorization: process.env.ALLTID_BRIDGE_TOKEN || '', ...withDevelopmentHeaders() },
    },
  );

  return response?.data?.data;
};
